import React from 'react';

import { BaseIconProps } from './icon-types';

export const PhoneB = ({ fill }: BaseIconProps) => (
  <g transform="matrix(22.277877,0,0,22.277877,-11069.632,-30700.781)">
    <path
      fill={fill}
      d="m 534.285,1425.51 4.138,-7.785 a 1.995,1.995 0 0 0 -0.521,-2.49 l -7.91,-6.225 a 1.977,1.977 0 0 0 -2.382,-0.048 l -5.252,3.775 c -5.35,-4.512 -9.096,-10.895 -10.35,-17.926 l 5.895,-2.662 a 1.98,1.98 0 0 0 1.15,-2.087 l -1.436,-9.962 a 2.006,2.006 0 0 0 -1.903,-1.707 l -8.81,-0.308 a 1.982,1.982 0 0 0 -1.985,1.47 c -5.475,20.432 6.636,41.455 27.101,46.939 a 1.98,1.98 0 0 0 2.265,-0.984 z"
    />
  </g>
);
